import classNames from 'clsx'
import { arrayOf, func, shape, string } from 'prop-types'
import { Component } from 'react'

import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import { isProductAvailable } from 'views/utils/productUtils'
import { ProductVariantType } from 'views/utils/propTypes'

class ProductVariants extends Component {
  handleClick = variant => {
    const { updateCurrentVariant } = this.props

    if (typeof updateCurrentVariant === 'function') {
      updateCurrentVariant(variant)
    }
  }

  render() {
    const { variants, currentVariantId } = this.props

    return (
      <div className="o-SearchProductListItem__variants u-position--relative u-padding--sides u-padding-small--ends u-border-radius--bottom-left u-border-radius--bottom-right u-background-color--greySky">
        <div className="o-SearchProductListItem__variants__spacing" />
        <ul className="o-SearchProductListItem__variants-list u-position--relative a-list-reset l-flex l-flex--center l-flex--wrap">
          {variants.map(variant => {
            const { id, unit, unitQuantityString, stockStatus } = variant
            const isNotAvailable = !isProductAvailable(stockStatus)
            const text = `${unitQuantityString} ${unit}`
            const buttonClass = classNames(
              'o-SearchProductListItem__variant-button',
              {
                'o-SearchProductListItem__variant-button--selected':
                  id === currentVariantId,
                'o-SearchProductListItem__variant-button--disabled':
                  isNotAvailable,
              }
            )

            return (
              <li key={id} className="o-SearchProductListItem__variant-item">
                <ButtonAsLink
                  onClick={() => this.handleClick(variant)}
                  name={`variant-link-${id}`}
                  data-clientside-hook="productVariantButton"
                  className={buttonClass}
                >
                  {text}
                </ButtonAsLink>
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}

ProductVariants.propTypes = {
  variants: arrayOf(shape(ProductVariantType)).isRequired,
  currentVariantId: string.isRequired,
  updateCurrentVariant: func.isRequired,
}

export default ProductVariants
